
/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/


Mindbreeze.define('service/wiring',["underscore", "backbone", "model/compute_wiring", "service/stub", "utils/clone"], function(_, Backbone, ComputeWiring, Stub, deepClone) {


  var ServiceWiring = ComputeWiring.extend({

   initialize: function(input, output, options) {
     this.channel = options.channel;
     this.serviceStub = options.serviceStub || new Stub();
   },

   // **implements the computation**
   performComputation: function(input, responseObserver) {

    var inputAtts = input.attributes;
    var request;
     try {
        inputAtts = deepClone(inputAtts);
        // allowed to mutate inputAtts without changing the input model
        this.trigger("compute", this, inputAtts);
     } catch (e) {
       if (console && console.log) console.log("Failed to trigger compute, reverting to original input", e);
       inputAtts = input.attributes;
     }

     request = input.toJSON(inputAtts);     
     return this.serviceStub.cast(this.channel, request, responseObserver);
   }

  });

  return ServiceWiring;


});
